import { useSelector } from 'react-redux';
import { TReducerRootState } from 'redux/types';
import { TCurrentSessionData } from 'types/app';

const useCurrentSessionData = () => {
    return useSelector<TReducerRootState, TCurrentSessionData>(
        (state) => state.app.currentSessionData,
    );
};

export default useCurrentSessionData;
